import { useSource } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Source } from "@opendash/plugin-parse/dist/types-generated";
import { Card, Col, Row, Statistic } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect, useState } from "react";
import { Schedule_Execution, Ticket_Source } from "../../../js/parsegenerated";

export default observer(() => {
  const [numberOfTickets, setNumberOfTickets] = useState<number>(0);
  const [numberOfSchedules, setNumberOfSchedules] = useState<number>(0);
  const [selectedSource] = useSource();

  const t = useTranslation();

  useEffect(() => {
    new Parse.Query(Ticket_Source)
      .equalTo("source", {
        __type: "Pointer",
        className: Source.className,
        objectId: selectedSource.id,
      })
      .count()
      .then(setNumberOfTickets);

    new Parse.Query(Schedule_Execution)
      .equalTo("source", {
        __type: "Pointer",
        className: Source.className,
        objectId: selectedSource.id,
      })
      .count()
      .then(setNumberOfSchedules);
  }, [selectedSource]);

  return (
    <Row gutter={16} style={{ marginBottom: 20 }}>
      <Col span={12}>
        {/* 
// @ts-ignore */}
        <Card variant="outlined">
          <Statistic
            title={t("maintenance:machinelog.headercards.numberoftickets")}
            value={numberOfTickets}
            precision={0}
            prefix={<Icon icon="fa:arrow-up" />}
            suffix="#"
          />
        </Card>
      </Col>
      <Col span={12}>
        {/* 
// @ts-ignore */}
        <Card variant="outlined">
          <Statistic
            title={t("maintenance:machinelog.headercards.numberofschedules")}
            value={numberOfSchedules}
            precision={0}
            prefix={<Icon icon="fa:arrow-up" />}
            suffix="#"
          />
        </Card>
      </Col>
    </Row>
  );
});
